export const setUserAction = (user) => ({
    type: 'SET_USER',
    payload: user
});

export const loadUserAction = () => ({
    type: 'LOAD_USER'
});


// WEBPACK FOOTER //
// ./src/actions/user.js